import theme from './default';

export default theme;
